export default __webpack_public_path__ + "static/DSC_0046-0bacc4cd39cae79449da54c7a0705233.jpg";